import { IonCard, IonCardContent, IonCardHeader } from "@ionic/react";
import React from "react";
import { keyExists } from "../common/commonFunctions";
import "./styles/Card.css";

const Card: React.FC<{
  title?: string;
  subtitle?: string;
  selected?: boolean;
  onClick?: () => void;
  statusColor?: "wip" | "complete" | "default";
  fullHeight?: boolean;
  vypzeeMode?: boolean;
}> = (props) => {
  const selected = keyExists("selected", props) ? props.selected : false;
  const status = keyExists("statusColor", props) ? props.statusColor : "";
  const cardCss = `card ${selected ? "card-selected" : ""} ${
    status === "complete" ? "card-complete" : status === "wip" ? "card-wip" : ""
  } ${
    keyExists("fullHeight", props) && props.fullHeight ? "card-full-height" : ""
  } ${props.vypzeeMode ? "card-vypzee" : ""}`;
  return (
    <IonCard
      className={cardCss}
      onClick={() => {
        if (keyExists("onClick", props)) props.onClick();
      }}
    >
      {keyExists("title", props) && (
        <IonCardHeader>
          <div
            className="card-header"
            style={{ color: props.vypzeeMode ? "yellow" : undefined }}
          >
            {props.title}
          </div>
          {!!props.subtitle && (
            <div
              style={{
                textAlign: "right",
                color: "var(--ion-color-dark)",
                marginTop: "5px",
                borderBottom: "2px solid var(--ion-color-secondary)",
              }}
            >
              {props.subtitle}
            </div>
          )}
        </IonCardHeader>
      )}
      <IonCardContent>{props.children}</IonCardContent>
    </IonCard>
  );
};

export default Card;
